/**
 * @ngdoc directive
 * @name vue.directive:vPlayerEmbed
 * This handles the embed player
 */

export default (vue) => {
    vue.ctx.scope.video.container = vue.el;
    vue.ctx.scope.video.element = vue.el.querySelector(".player-video");
    vue.ctx.scope.video.range = vue.el.querySelector(".player-range");
    vue.ctx.scope.video.volume = vue.el.querySelector(".player-volume");
    vue.ctx.scope.video.preview = vue.el.querySelector(".player-preview");
    vue.ctx.scope.video.ready();
};